import { useMutation } from 'react-query'
import { authUseCase } from '../../factories'

const useChangePassword = () => useMutation(authUseCase.changePassword)

export default useChangePassword
